module.exports = __webpack_public_path__ + "e51e20cc982c05ac474af1d2fdfb9309.glb";